import React, { useState } from "react";
import styles from "../components/css/Pagenation.module.css";
import { ArrowLeft, ArrowRight } from "lucide-react";

const pages = [1, 2, 3, 4, 5];

const Pagenation = () => {
  const [currentPage, setCurrentPage] = useState(1);

  const handlePrevClick = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextClick = () => {
    if (currentPage < pages.length) {
      setCurrentPage(currentPage + 1);
    }
  };

  return (
    <div className={styles.paginationWrapper}>
      <nav aria-label="Page navigation example">
        <ul className={styles.pagination}>
          <li className={styles.pageItem}>
            <a className={styles.pageLeft} href="#" aria-label="Previous">
              <span aria-hidden="true" onClick={handlePrevClick}>
                <ArrowLeft />
              </span>
            </a>
          </li>

          {pages.map((page) => {
            const isActive = currentPage === page;
            return (
              <li key={page} className={styles.pageItem}>
                <a
                  className={`${styles.pageLink} ${
                    isActive ? styles.active : ""
                  }`}
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setCurrentPage(page);
                  }}
                >
                  {page}
                </a>
              </li>
            );
          })}

          <li className={styles.pageItem}>
            <a className={styles.pageRight} href="#" aria-label="Next">
              <span aria-hidden="true" onClick={handleNextClick}>
                <ArrowRight />
              </span>
            </a>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Pagenation;
